import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const JOB_SERIES_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<JobSeries>[] = [
    { name: "type_label", label: "Generation Mode" },
    { name: "recurrence_interval", label: "Recurrence" },
    { name: "recurrence_start", label: "Start Date" },
    { name: "recurrence_end", label: "End Date" },
    { name: "completion_progress", label: "Completion" },
    { name: "open_jobs_count", label: "Open Jobs" },
]

export const JOB_SERIES_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<JobSeries>[] = [
    { name: "service_name", label: "Service" },
    { name: "client_name", label: "Client" },
    { name: "service_location_name", label: "Location Name" },
    { name: "service_location_address", label: "Location Address" },
    { name: "type_label", label: "Type" },
    { name: "recurrence_start", label: "Recurrence Start" },
    { name: "recurrence_end", label: "Recurrence End" },
    { name: "open_jobs_count", label: "Open Jobs" },
    { name: "created_at", label: "Created At" },
]
